import { atom } from "recoil";
import { ApprovalResponseProps } from "./approval-response-props";

export const approvalResponseState = atom<ApprovalResponseProps | null>({
  key: "approvalResponseState",
  default: null,
});
